import * as d3 from 'd3'

export const colorRange = ['#3661AD', '#b4cfd1', '#b4cfd1', '#D82129']

export const percentileDomain = [5, 45, 55, 95]

export const colorScale = d3
    .scaleLinear<string>()
    .range(colorRange)
    .domain(percentileDomain)
    .clamp(true)
    .interpolate(d3.interpolateLab)
